import { useTranslation } from "react-i18next";
import "../../../i18n";
import { KeyValues, Notice } from "../../../design/components";
import type { DocumentDetail } from "../../../api/types";
import styles from "./DocumentInspector.module.css";

function sha(doc: DocumentDetail, kind: string): string | null {
  return doc.artifacts.find((artifact) => artifact.kind === kind)?.sha256 ?? null;
}

/** M1 has no /archive endpoint; the sealed record is read from the detail's artifacts. */
export function ArchivePanel({ doc }: { doc: DocumentDetail }) {
  const { t } = useTranslation();
  const sealed = doc.stage === "archived";
  const xml = sha(doc, "xml");
  const ack = sha(doc, "ack");

  return (
    <section className="card">
      <div className="card-head">
        <h2 className="grow">{t("documents.inspector.archive.title", "Archive")}</h2>
      </div>
      <div className="card-body">
        {sealed ? (
          <KeyValues
            pairs={[
              [t("documents.inspector.archive.sealedXml", "Sealed XML"), <span className={styles.sha}>{xml ?? "—"}</span>],
              [
                t("documents.inspector.archive.ackRecord", "Acknowledgement record"),
                <span className={styles.sha}>{ack ?? "—"}</span>,
              ],
            ]}
          />
        ) : (
          <Notice kind="info">{t("documents.inspector.archive.notSealed", "This document is not sealed yet")}</Notice>
        )}
      </div>
    </section>
  );
}
